import React, {useEffect, useState} from 'react';
import {makeStyles, useMediaQuery} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import { Loading} from '@cabinet-packages/components';
import { getCatalog, selectActivePatientResults} from "@cabinet-packages/redux";
import Typography from "@material-ui/core/Typography";
import ResultAccordion from "../components/Accordions/ResultAccordion";
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from "moment";

const useStyles = makeStyles(theme =>({
  headerLabel: {
    color: theme.palette.primary.dark
  },
  extraLabel: {
    color: theme.palette.primary.main
  },
  scrollContainer: {
    display:"flex",
    flexDirection: 'column',
    justifyContent: "flex-start",
    padding: "0px 10px",
    width: "100%",
    height: 'calc(100vh)',
    overflowY: "auto", // Allow vertical scrolling when needed
    "@media(min-width: 1000px)": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  assaysWrapper: {
    maxHeight: "100%", // Adjust height as needed
    overflowY: "auto", // Enable vertical scrolling

    "@media(min-width: 1000px)": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  resultsContainer: {
    marginTop: '20px',
    padding: '10px 0',
    height: 'max-content',
    overflowY: "auto",

    '@media (max-width:900px)': {
      padding: '2px 0',
      marginTop: '5px'
    },
  },
  columnLabelsContainer: {
    display: 'grid',
    gridTemplateColumns: '100px 0.5fr 1.5fr 1.5fr 1fr',
    gap: "10px",
    height: '15px',
    padding: '0px 0px 0px 16px',
    width: 'calc(100% - 44px)',
    '@media(max-width: 900px)': {
      display: 'none'
    }
  },
  columnLabel: {
    fontSize: '12px',
    color: theme.palette.grey.text,
    fontWeight: 500,
    '@media(max-width: 900px)': {
      fontSize: '9px'
    }
  },
  noPatient: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    textAlign: 'center',
    margin: '200px',
    '@media(max-width: 900px)': {
      margin: '50px',
    }
  },
  noResults: {
    textAlign: 'center'
  },
}));

function CabinetPatientResults() {
  const classes = useStyles()
  const {catalog, takeId, complexId}  = useSelector(state => state.assaysCatalog);
  const { activePatientResults, activePatient, listOfPatients } = useSelector(state => state.patients);
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [pages, setPages] = useState(10);
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))

  useEffect(() => {
    if (!activePatientResults && listOfPatients) {
      dispatch(selectActivePatientResults());
    }
// console.log(activePatientResults, 'activePatientResults')
    if (activePatientResults && typeof activePatientResults !== "string" && !expanded) {
      setExpanded(activePatientResults.reduce((acu, cur, idx) => {
        if (idx === 0) return ({...acu, [cur.idOrder]: true})
        return {...acu, [cur.idOrder]: false};
      }, {}))
    }
  }, [dispatch, activePatientResults, listOfPatients, expanded]);

  useEffect(() => {
    if (!catalog && takeId && complexId) {
      dispatch(getCatalog())
    }
  }, [catalog, takeId, complexId]);

  const handleChangePagination = (e, page)=> {
    setPages(page*10)
  }

  return (
      <div className={classes.scrollContainer}>
        <div style={{padding: '4px 0'}}>
          <Typography className={classes.extraLabel}>
            Тут відображаються поточні результати досліджень
          </Typography>
        </div>
        <div className={classes.assaysWrapper}>
          {activePatientResults && activePatientResults.length > 0
              ?
              <div className={classes.resultsContainer}>
                {listOfPatients && Array.isArray(activePatientResults) && (activePatientResults || [])
                    ?.filter(item => {
                      return +item.ready !== 0;
                    })?.length === 0 && <p className={classes.noResults}>У вас ще немає готових результатів.</p>
                }
                <div className={classes.accordionsContainer}>
                  <div className={classes.columnLabelsContainer}>
                    <Typography className={classes.columnLabel}>
                      PDF
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      ID
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      ПІБ
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      Час здачі
                    </Typography>
                    <Typography className={classes.columnLabel}>
                      Адреса
                    </Typography>
                  </div>
                  {listOfPatients && activePatientResults && activePatientResults.length > 0
                      && typeof activePatientResults !== "string" && typeof listOfPatients !== 'string'
                      && [...(Array.isArray(activePatientResults) ? activePatientResults : [])]?.sort((a, b) => {

                    return moment(b.dt).clone().diff(moment(a.dt))
                  }).slice(pages-10,pages).map((result,idx) => (
                      <ResultAccordion
                          key={`${result.idOrder} ${idx}`}
                          result={result}
                          uniqIndex={result.idOrder}
                          expanded={expanded}
                          setExpanded={setExpanded}
                      />
                  ))}
                </div>
              </div>
              : activePatientResults && activePatientResults.length === 0 && typeof listOfPatients !== 'string'
                  ?
                  <div className={classes.noPatient}>
                    <Typography color={"textSecondary"}>
                      Немає поточних досліджень для
                      {activePatient && <strong>
                        {` ${activePatient.lastname}
                     ${activePatient.firstname}
                     ${activePatient.fathername}.`}
                      </strong>}
                    </Typography>
                  </div>
                  : typeof activePatientResults === "string"
                      ? <div className={classes.noPatient}>Вибачте, сталась помилка під час завантаження.</div>
                      : <div className={classes.noPatient}>
                        <Loading/>
                      </div>}
        </div>
        {listOfPatients && activePatientResults && activePatientResults.length > 0
        && typeof activePatientResults !== "string" && typeof listOfPatients !== 'string' &&
        activePatientResults.filter(item => +item.ready !== 0).length > 10
            ? <Stack spacing={2} alignItems={'center'} style={{marginTop: 'auto'}}>
              <Pagination
                  onChange={handleChangePagination}
                  count={Math.ceil(activePatientResults.filter(item => +item.ready !== 0).length/10)}
                  renderItem={(item) => (
                      <PaginationItem
                          slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                          {...item}
                      />
                  )}
              />
            </Stack>
            : <div/>}
      </div>
  );
}

export default CabinetPatientResults;
